import { CERequirementBase } from './ce-requirement-base'


export class CERequirement extends CERequirementBase {

}